import React from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateProjectStatusReduxParams } from '~types/feat/approval';

import { ProjectChangeHistoryStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateProjectStatusModal.module.scss';

const ConfirmUpdateProjectStatusModal = () => {
    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateProjectStatusModalIsOpen);
    const tempUpdateProjectState = useAppSelector(state => state.approval.tempUpdateProjectState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateProjectStatus);
    const error = useAppSelector(state => state.approval.errors.updateProjectStatus);

    const getStatus = () => {
        switch (tempUpdateProjectState.status) {
            case (ProjectChangeHistoryStatusEnum.Approved): return 'Approve';
            case (ProjectChangeHistoryStatusEnum.Rejected): return 'Reject';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateProjectStatusModalIsOpen(open));
    const updateProjectStatus = (data: TUpdateProjectStatusReduxParams) => dispatch(combinedActions.approvalUpdateProjectStatusAttempt(data));

    const handleSubmitClick = () => {
        updateProjectStatus(tempUpdateProjectState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Approve' ? Styles['confirm-approve'] : ''),
        (getStatus() === 'Reject' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateProjectStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Project?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                    disabled={isLoading}
                />

                <ActionButton
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateProjectStatusModal;
